export default "__VITE_ASSET__ea37e7b0__"